export default __webpack_public_path__ + "static/media/hard-drive.19e87df5.svg";